export default "__VITE_ASSET__c666da6c__"